// config_names.js
const config_names = {
    projectName: "InstantTranscriber",
    projectName_genitive: "InstantTranscriber's",
    projectDomain: "InstantTranscriber.com",
    allow_skip_login_for_now: false,
    contactEmail: "contact@instanttranscriber.com",
    jurisdiction: "Switzerland",
    operating_country: "Switzerland",
    effectiveDate: "March 1, 2025",
    domain: "https://test.instanttranscriber.com",
  };
  
  export default config_names;